import React, { useEffect, useState } from 'react'
import { Button, ListGroup, Modal } from 'react-bootstrap'
import { useAuth } from '../../../../firebase/AuthProvider';
import { GetAllArchivedChannelsAsync } from '../../../../services/channelService/ChannelService';
import { GetArchivedChannelRes } from '../../../../interfaces/channelDtos/channelDtos';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/free-solid-svg-icons';

interface ArchivedChannelModalProps {
    showChannelModal: boolean;
    handleCloseChannelModal: () => void;
    updateArchivedStatusOfChannel: (chanelId: string, status: boolean) => void;
    archivedChannelRefreshKey: number;
}

const ArchivedChannelModal: React.FC<ArchivedChannelModalProps> = ({
    handleCloseChannelModal,
    showChannelModal,
    updateArchivedStatusOfChannel,
    archivedChannelRefreshKey
}) => {
    const { currentUser } = useAuth();

    // data
    const [archivedChannelList, setArchivedChannelList] = useState<GetArchivedChannelRes[]>([]);

    //other
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        getAllArchivedChannels();
    }, [currentUser, archivedChannelRefreshKey]);


    const getAllArchivedChannels = async () => {
        if (!currentUser) return;
        const token = await currentUser.getIdToken();

        setLoading(true);
        setArchivedChannelList([]);
        GetAllArchivedChannelsAsync(token).then((res) => {
            if (res.success) {
                setArchivedChannelList(res.data);
            }
        }).catch((err) => {
        }).finally(() => {
            setLoading(false);
        })

    }
    return (
        <>
            <Modal show={showChannelModal} onHide={handleCloseChannelModal} className="custom_popup" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Archived Channel List</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
                    <ListGroup>
                        {loading ? (
                            <div className='text-center'>
                                <p>Loading...</p>
                            </div>
                        ) : (
                            archivedChannelList.length === 0
                                ? (
                                    <div className='text-center'><p>No Data Found</p></div>
                                )
                                : (
                                    <>
                                        {archivedChannelList?.map((channel, index) => (
                                            <ListGroup.Item
                                                key={index}
                                                className="d-flex justify-content-between align-items-center"
                                            >
                                                <div>{channel.name}</div>

                                                <Button
                                                    variant="outline-success"
                                                    size="sm"
                                                    className="d-flex align-items-center"
                                                    onClick={() => updateArchivedStatusOfChannel(channel.channelId, false)} // false = unarchive
                                                >
                                                    <FontAwesomeIcon icon={faUndo} className="me-1" />
                                                    Undo
                                                </Button>
                                            </ListGroup.Item>
                                        ))}
                                    </>
                                )
                        )
                        }

                    </ListGroup>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseChannelModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default ArchivedChannelModal